import { ListaStatusAlocacao } from './listaStatusStyles'

const STATUS_COTA_ALOCADO = 'A'
const STATUS_COTA_NAO_ALOCADA = 'N'
const STATUS_FALHA_ALOCACAO = 'F'
const STATUS_COTA_CANCELADA = 'C'

export const StatusAlocacoes = {
  Alocado: STATUS_COTA_ALOCADO,
  NaoAlocado: STATUS_COTA_NAO_ALOCADA,
  FalhaAlocacao: STATUS_FALHA_ALOCACAO,
  Cancelada: STATUS_COTA_CANCELADA
}

export const StatusAlocacoesDesc = {
  [StatusAlocacoes.Cancelada]: 'Cancelada',
  [StatusAlocacoes.FalhaAlocacao]: 'Falha Na Alocação',
  [StatusAlocacoes.Alocado]: 'Alocada',
  [StatusAlocacoes.NaoAlocado]: 'Não Alocada'
}
export const ListaStatusAlocacaoPrioridade = {
  [StatusAlocacoesDesc[StatusAlocacoes.FalhaAlocacao]]: 1,
  [StatusAlocacoesDesc[StatusAlocacoes.Cancelada]]: 2,
  [StatusAlocacoesDesc[StatusAlocacoes.NaoAlocado]]: 3,
  [StatusAlocacoesDesc[StatusAlocacoes.Alocado]]: 4
}
export function getEstilosStatusAlocacao (status_alocacao) {
  if (!status_alocacao) {
    status_alocacao = StatusAlocacoes.NaoAlocado
  }
  return ListaStatusAlocacao[status_alocacao]
}

export function getStatusAlocacao (status_alocacao) {
  if (!status_alocacao) {
    status_alocacao = StatusAlocacoes.NaoAlocado
  }
  return status_alocacao
}

export function getStatusAlocacaoDesc (status_alocacao) {
  if (!status_alocacao) {
    status_alocacao = StatusAlocacoes.NaoAlocado
  }
  return StatusAlocacoesDesc[status_alocacao]
}
